import {useEffect} from 'react'

import {GALLERY_URL_PARAM} from './config.js'

const setGalleryUrlParam = isOpen => {
  const url = new URL(window.location.href)
  if (url.searchParams.has(GALLERY_URL_PARAM) === isOpen) return

  if (isOpen) url.searchParams.set(GALLERY_URL_PARAM, String(Date.now()))
  else url.searchParams.delete(GALLERY_URL_PARAM)

  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`)
}

// Fuse only registers a slot mounted after page load when the URL changed before `pageInit` runs.
// replaceState adds no history entry and fires no popstate, so the router never sees it.
// The value is a timestamp, unique per open: reopening with the same URL as the last pageInit registers no slot.
const useGalleryUrlParam = isOpen => {
  // The modal always starts closed, so a param left by a refresh or a shared link is stale.
  useEffect(() => {
    setGalleryUrlParam(false)
  }, [])

  useEffect(() => {
    if (!isOpen) return
    setGalleryUrlParam(true)
    return () => setGalleryUrlParam(false)
  }, [isOpen])
}

export default useGalleryUrlParam
